<template>
  <v-card height="100%" flat width="100%">
    <!-- <v-row v-if="!hasCompletedPurchase" no-gutters style="height: 100%">
    </v-row> -->
    <v-row no-gutters style="height: 100%">
      <v-col
        :cols="isMobileBreakpoint ? '12' : '6'"
        :class="isMobileBreakpoint ? '' : 'px-4'"
        :style="firstStepStyle"
      >
        <v-row no-gutters>
          <v-col cols="12">
            <v-card flat>
              <v-card-text class="py-0 mt-4 px-0">
                <v-row no-gutters justify="center" class="pl-1">
                  <v-col cols="12">
                    <v-col
                      cols="12"
                      class="d-flex align-center justify-space-between"
                    >
                      <v-card
                        :width="plan.title.match('Legacy') ? '200px' : '94px'"
                        height="38px"
                        color="#e6e8f8"
                        class="d-flex flex-row align-center justify-center rounded-pill"
                        flat
                      >
                        <span class="cartPlanText my-auto primary--text">
                          {{ plan.title }}
                        </span>
                      </v-card>
                      <span
                        @click="handleBackPlans"
                        class="primary--text customizeChangePlanText"
                        style="cursor: pointer"
                        >{{ $t('message.pages.customizeModal.change') }}</span
                      >
                    </v-col>
                    <v-col cols="12" class="pb-0">
                      <v-row no-gutters justify="space-between">
                        <span>
                          <v-icon color="lightenText" size="16" class="mr-2">
                            mdi-check-circle
                          </v-icon>
                          <span
                            ><b
                              >{{ formatNumberToBR(plan.storage) }} GB
                              <span
                                v-if="
                                  calcBytes(plan.storage).slice(-2) !== 'GB'
                                "
                              >
                                ({{ calcBytes(plan.storage) }})
                              </span>
                            </b>
                            {{ $t('message.ofStorage') }}
                          </span>
                        </span>
                        <span>
                          <b>
                            {{
                              plan.price.toLocaleString(currencyLocale, {
                                style: 'currency',
                                currency: currency,
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            }}
                          </b>
                        </span>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="pb-0">
                      <v-icon color="lightenText" size="16" class="mr-2">
                        mdi-check-circle
                      </v-icon>

                      <span>
                        <b
                          >{{ formatNumberToBR(plan.traffic) }} GB
                          <span
                            v-if="calcBytes(plan.storage).slice(-2) !== 'GB'"
                          >
                            ({{ calcBytes(plan.traffic) }})
                          </span>
                        </b>
                        {{ $t('message.ofTraffic') }}</span
                      >
                    </v-col>
                    <v-col cols="12" class="pb-0">
                      <v-icon color="lightenText" size="16" class="mr-2">
                        mdi-check-circle
                      </v-icon>

                      <span>{{
                        $t('message.pages.customizeModal.perk1')
                      }}</span>
                    </v-col>
                    <v-col cols="12" class="pb-0">
                      <v-icon color="lightenText" size="16" class="mr-2">
                        mdi-check-circle
                      </v-icon>

                      <span
                        >{{ $t('message.pages.customizeModal.perk6') }}
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon x-small class="pa-0 intro__btn">
                              <v-icon x-small v-on="on" v-bind="attrs"
                                >mdi-help</v-icon
                              >
                            </v-btn>
                          </template>
                          <span>{{
                            $t(
                              'message.pages.customizeModal.unlimitedLivestream'
                            )
                          }}</span>
                        </v-tooltip>
                      </span>
                    </v-col>
                    <v-col
                      cols="12"
                      class="pb-0"
                      v-if="plan.title === 'Silver' || plan.title === 'Bronze'"
                    >
                      <v-icon color="lightenText" size="16" class="mr-2">
                        mdi-check-circle
                      </v-icon>
                      <span
                        >1 {{ $t('message.pages.Cart.simultaneousLive') }}</span
                      >
                    </v-col>
                    <v-col cols="12" class="pb-0" v-if="plan.title === 'Gold'">
                      <v-icon color="lightenText" size="16" class="mr-2">
                        mdi-check-circle
                      </v-icon>

                      <span
                        >{{ $t('message.pages.Cart.even') }} 2
                        {{ $t('message.pages.Cart.simultaneousLives') }}</span
                      >
                    </v-col>
                    <v-col cols="12" class="pb-0" v-if="plan.title === 'Gold'">
                      <v-icon color="lightenText" size="16" class="mr-2">
                        mdi-check-circle
                      </v-icon>

                      <span
                        >{{ $t('message.pages.customizeModal.perk5') }}
                        {{ $t('message.pages.customizeModal.perk7') }}.
                      </span>
                    </v-col>
                    <v-col cols="12" class="pb-0">
                      <span
                        v-if="plan.title === 'Gold' || plan.title === 'Silver'"
                      >
                        <v-icon color="lightenText" size="16" class="mr-2">
                          mdi-check-circle
                        </v-icon>
                        {{ $t('message.pages.Cart.even') }}
                        {{ plan.users }}
                        {{
                          $t(
                            'message.pages.customizeModal.addonUsers'
                          ).toLowerCase()
                        }}
                      </span>
                    </v-col>
                    <v-col cols="12">
                      <v-divider />
                    </v-col>
                    <v-col
                      v-if="storageAddon.price_id"
                      cols="12"
                      :class="isMobileBreakpoint ? 'mt-2 caption' : ' py-2'"
                    >
                      <v-row no-gutters>
                        <v-col
                          cols="12"
                          class="d-flex flex-row justify-space-between"
                        >
                          <v-row no-gutters>
                            <v-col
                              :cols="isMobileBreakpoint ? '12' : '6'"
                              class="d-flex justify-start px-0"
                            >
                              <span style="line-height: 0">
                                <span
                                  :class="{
                                    blackSubtitle: !$vuetify.theme.dark,
                                  }"
                                  class="customizeItemsText"
                                  style="line-height: 130%"
                                  >{{
                                    $t(
                                      'message.pages.customizeModal.additionalStorage'
                                    )
                                  }}
                                </span>
                                <br />
                                <small v-if="storageAddon.transform_usage">
                                  {{
                                    $t('message.pages.customizeModal.prePaid')
                                  }}:
                                  {{
                                    (
                                      storageAddon.unit_amount / 100
                                    ).toLocaleString(currencyLocale, {
                                      style: 'currency',
                                      currency: currency,
                                    })
                                  }}
                                  {{ $t('message.pages.customizeModal.each') }}
                                  {{ storageAddon.transform_usage.divide_by }}
                                  GB
                                </small>
                                <small v-else>
                                  {{
                                    $t('message.pages.customizeModal.prePaid')
                                  }}:
                                  {{
                                    (
                                      storageAddon.unit_amount / 100
                                    ).toLocaleString(currencyLocale, {
                                      style: 'currency',
                                      currency: currency,
                                    })
                                  }}
                                  {{ $t('message.pages.customizeModal.each') }}
                                  GB
                                </small>
                                <br />
                                <span>
                                  <small
                                    v-if="userPlanInfo.limit.storage > 1"
                                    :class="{
                                      'red--text': isCurrentStorageOut,
                                    }"
                                    >{{
                                      $t(
                                        'message.pages.customizeModal.inUsage'
                                      )
                                    }}:
                                    {{
                                      calcMegabytes(
                                        userPlanInfo.limit.storage,
                                        'MB',
                                        'GB',
                                        true
                                      )
                                    }}</small
                                  >
                                  <small v-else
                                    >{{
                                      $t(
                                        'message.pages.customizeModal.inUsage'
                                      )
                                    }}: 0 GB</small
                                  >
                                </span>
                              </span>
                            </v-col>
                            <v-col
                              :cols="isMobileBreakpoint ? '12' : '6'"
                              class="d-flex align-center"
                            >
                              <v-row no-gutters justify="end" align="center">
                                <span
                                  v-if="fixedAddonAmount"
                                  class="mr-3 cartPlanText primary--text"
                                >
                                  {{ fixedAddonAmount }}
                                </span>
                                <v-card
                                  class="d-flex flex-row"
                                  width="74px"
                                  height="32px"
                                  flat
                                >
                                  <v-card
                                    class="d-flex flex-row align-center justify-center"
                                    width="36px"
                                    height="100%"
                                    flat
                                    color="#EBEDFF"
                                    style="
                                      border-top-right-radius: 0px;
                                      border-bottom-right-radius: 0px;
                                      cursor: pointer;
                                    "
                                    @click="handleRemoveStorage"
                                  >
                                    <v-icon
                                      :class="{
                                        'v-icon--keep-light':
                                          $vuetify.theme.dark,
                                      }"
                                    >
                                      mdi-minus
                                    </v-icon>
                                  </v-card>
                                  <v-card
                                    class="d-flex flex-row align-center justify-center"
                                    width="36px"
                                    height="100%"
                                    flat
                                    color="primary"
                                    style="
                                      border-top-left-radius: 0px;
                                      border-bottom-left-radius: 0px;
                                      cursor: pointer;
                                    "
                                    @click="handleAddStorage"
                                  >
                                    <v-icon color="white">mdi-plus</v-icon>
                                  </v-card>
                                </v-card>
                                <v-tooltip top v-if="errors.removeStorageError">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      class="ml-2"
                                      size="22"
                                      color="red"
                                      v-bind="attrs"
                                      v-on="on"
                                      >mdi-alert</v-icon
                                    >
                                  </template>
                                  <span>{{
                                    $t(
                                      'message.pages.customizeModal.usedStorage'
                                    )
                                  }}</span>
                                </v-tooltip>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-card
                            v-if="errors.removeStorageError"
                            class="d-flex align-center justify-center"
                            width="100%"
                            height="20px"
                            flat
                          >
                            <span class="error--text">{{
                              $t('message.pages.customizeModal.storageError')
                            }}</span>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="12"
                      class="py-2"
                      style="padding-bottom: 14px !important"
                      v-if="trafficAddon.price_id"
                    >
                      <v-row no-gutters>
                        <v-col
                          cols="12"
                          class="d-flex flex-row justify-space-between align-center"
                        >
                          <v-row no-gutters>
                            <v-col
                              :cols="isMobileBreakpoint ? '12' : '6'"
                              class="d-flex justify-start"
                            >
                              <span style="line-height: 0">
                                <span
                                  :class="{
                                    blackSubtitle: !$vuetify.theme.dark,
                                  }"
                                  class="customizeItemsText"
                                  style="line-height: 130%"
                                  >{{
                                    $t(
                                      'message.pages.customizeModal.additionalTraffic'
                                    )
                                  }}
                                </span>
                                <br />
                                <small
                                  >{{
                                    $t('message.pages.customizeModal.prePaid')
                                  }}:
                                  {{
                                    `${(
                                      trafficAddon.unit_amount / 100
                                    ).toLocaleString(currencyLocale, {
                                      style: 'currency',
                                      currency: currency,
                                    })} ${$t(
                                      'message.pages.customizeModal.each'
                                    )} GB`
                                  }}
                                </small>
                                <br />
                                <small>
                                  {{
                                    $t('message.pages.customizeModal.posPaid')
                                  }}:
                                  {{
                                    (
                                      posPaidTrafficAddon.unit_amount / 100
                                    ).toLocaleString(currencyLocale, {
                                      style: 'currency',
                                      currency: currency,
                                    })
                                  }}
                                  {{ $t('message.pages.customizeModal.each') }}
                                  GB
                                </small>
                                <br />
                                <span
                                  style="line-height: 15px; margin-top: 5px"
                                >
                                  <template
                                    v-if="userPlanInfo.limit.estimated_traffic"
                                  >
                                    <small>
                                      <b
                                        >{{
                                          $t(
                                            'message.pages.customizeModal.estimate'
                                          )
                                        }}:
                                        {{
                                          calcMegabytes(
                                            userPlanInfo.limit
                                              .estimated_traffic,
                                            'MB',
                                            'GB',
                                            true
                                          )
                                        }}</b
                                      >
                                    </small>
                                    <small
                                      v-if="userPlanInfo.limit.traffic > 1"
                                      style="margin-top: -7px"
                                      :class="{
                                        'red--text': isCurrentBandwidthOut,
                                      }"
                                    >
                                      <br />
                                      {{
                                        $t(
                                          'message.pages.customizeModal.inUsage'
                                        )
                                      }}:
                                      {{
                                        calcMegabytes(
                                          userPlanInfo.limit.traffic,
                                          'MB',
                                          'GB',
                                          true
                                        )
                                      }}
                                    </small>
                                    <small v-else style="margin-top: -7px">
                                      <br />
                                      {{
                                        $t(
                                          'message.pages.customizeModal.inUsage'
                                        )
                                      }}: 0 GB
                                    </small>
                                  </template>
                                  <template v-else>
                                    <small
                                      v-if="
                                        userPlanInfo.limit.estimated_traffic > 1
                                      "
                                    >
                                      <b
                                        >{{
                                          $t(
                                            'message.pages.customizeModal.estimate'
                                          )
                                        }}:
                                        {{
                                          calcMegabytes(
                                            userPlanInfo.limit
                                              .estimated_traffic,
                                            'MB',
                                            'GB',
                                            true
                                          )
                                        }}</b
                                      >
                                    </small>
                                    <small
                                      v-if="userPlanInfo.limit.traffic > 1"
                                    >
                                      {{
                                        $t(
                                          'message.pages.customizeModal.inUsage'
                                        )
                                      }}:
                                      {{
                                        calcMegabytes(
                                          userPlanInfo.limit.traffic,
                                          'MB',
                                          'GB',
                                          true
                                        )
                                      }}
                                    </small>
                                    <small v-else>
                                      {{
                                        $t(
                                          'message.pages.customizeModal.inUsage'
                                        )
                                      }}: 0 GB
                                    </small>
                                  </template>
                                </span>
                              </span>
                            </v-col>
                            <v-col
                              :cols="isMobileBreakpoint ? '12' : '6'"
                              class="d-flex align-center"
                            >
                              <v-row no-gutters justify="end" align="center">
                                <span
                                  v-if="fixedTrafficAmount"
                                  class="mr-3 cartPlanText primary--text"
                                >
                                  {{ fixedTrafficAmount }}
                                </span>
                                <v-card
                                  class="d-flex flex-row"
                                  width="74px"
                                  height="32px"
                                  flat
                                >
                                  <v-card
                                    class="d-flex flex-row align-center justify-center"
                                    width="36px"
                                    height="100%"
                                    flat
                                    color="#EBEDFF"
                                    style="
                                      border-top-right-radius: 0px;
                                      border-bottom-right-radius: 0px;
                                      cursor: pointer;
                                    "
                                    @click="handleRemoveTraffic"
                                  >
                                    <v-icon
                                      :class="{
                                        'v-icon--keep-light':
                                          $vuetify.theme.dark,
                                      }"
                                    >
                                      mdi-minus
                                    </v-icon>
                                  </v-card>
                                  <v-card
                                    class="d-flex flex-row align-center justify-center"
                                    width="36px"
                                    height="100%"
                                    flat
                                    color="primary"
                                    style="
                                      border-top-left-radius: 0px;
                                      border-bottom-left-radius: 0px;
                                      cursor: pointer;
                                    "
                                    @click="handleAddTraffic"
                                  >
                                    <v-icon color="white">mdi-plus</v-icon>
                                  </v-card>
                                </v-card>
                                <v-tooltip top v-if="errors.removeTrafficError">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      class="pl-2 pb-6"
                                      size="22"
                                      color="red"
                                      v-bind="attrs"
                                      v-on="on"
                                      >mdi-alert</v-icon
                                    >
                                  </template>
                                  <span>{{
                                    $t(
                                      'message.pages.customizeModal.usedTraffic'
                                    )
                                  }}</span>
                                </v-tooltip>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" v-if="errors.removeTrafficError">
                          <v-card
                            class="d-flex flex-column align-center justify-center mt-3"
                            width="100%"
                            flat
                          >
                            <span class="error--text">{{
                              $t('message.pages.customizeModal.trafficError')
                            }}</span>
                            <small
                              class="text-left"
                              style="
                                width: 100%;
                                font-size: 10px;
                                line-height: 13px;
                              "
                              >{{
                                $t(
                                  'message.pages.customizeModal.additionalTrafficMessage',
                                  {
                                    price: (
                                      trafficAddon.unit_amount / 100
                                    ).toLocaleString(currencyLocale, {
                                      style: 'currency',
                                      currency: currency,
                                    }),
                                  }
                                )
                              }}
                              <a target="_blank" :href="trafficLink">
                                {{
                                  $t(
                                    'message.pages.customizeModal.additionalTrafficMessage2'
                                  )
                                }}</a
                              >
                            </small>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-divider />
                    </v-col>
                    <v-col cols="12" v-if="liveAddon.price_id">
                      <v-row no-gutters>
                        <v-col
                          cols="12"
                          class="d-flex flex-row justify-space-between align-center"
                        >
                          <v-row no-gutters>
                            <v-col
                              :cols="isMobileBreakpoint ? '12' : '6'"
                              class="d-flex justify-start px-0"
                            >
                              <span style="line-height: 130%"
                                ><span
                                  :class="{
                                    blackSubtitle: !$vuetify.theme.dark,
                                  }"
                                  class="customizeItemsText"
                                  >{{
                                    $t('message.pages.customizeModal.addonLive')
                                  }}</span
                                >
                                <br />
                                <small
                                  >{{
                                    (
                                      (liveAddon.unit_amount / 100) *
                                      60
                                    ).toLocaleString(currencyLocale, {
                                      style: 'currency',
                                      currency: currency,
                                    })
                                  }}
                                  {{
                                    $t('message.pages.Cart.everyMinutesOfLive')
                                  }}</small
                                >
                                <br />
                                <small v-if="posPaidLiveAddon"
                                  >{{
                                    $t('message.pages.customizeModal.posPaid')
                                  }}:
                                  {{
                                    (
                                      posPaidLiveAddon.unit_amount / 100
                                    ).toLocaleString(currencyLocale, {
                                      style: 'currency',
                                      currency: currency,
                                    })
                                  }}
                                  {{
                                    $t('message.pages.customizeModal.byMinute')
                                  }}</small
                                >
                              </span>
                            </v-col>
                            <v-col
                              :cols="isMobileBreakpoint ? '12' : '6'"
                              class="d-flex align-center"
                            >
                              <v-row no-gutters justify="end" align="center">
                                <span
                                  v-if="adicionalLiveAmount > 0"
                                  class="mr-3 cartPlanText primary--text"
                                >
                                  {{ adicionalLiveAmount }}
                                  {{
                                    adicionalLiveAmount > 1 ? 'lives' : 'live'
                                  }}
                                </span>
                                <v-card
                                  class="d-flex flex-row"
                                  width="74px"
                                  height="32px"
                                  flat
                                >
                                  <v-card
                                    class="d-flex flex-row align-center justify-center"
                                    width="36px"
                                    height="100%"
                                    flat
                                    color="#EBEDFF"
                                    style="
                                      border-top-right-radius: 0px;
                                      border-bottom-right-radius: 0px;
                                      cursor: pointer;
                                    "
                                    @click="handleAddLive"
                                  >
                                    <v-icon
                                      :class="{
                                        'v-icon--keep-light':
                                          $vuetify.theme.dark,
                                      }"
                                    >
                                      mdi-minus
                                    </v-icon>
                                  </v-card>
                                  <v-card
                                    class="d-flex flex-row align-center justify-center"
                                    width="36px"
                                    height="100%"
                                    flat
                                    color="primary"
                                    style="
                                      border-top-left-radius: 0px;
                                      border-bottom-left-radius: 0px;
                                      cursor: pointer;
                                    "
                                    @click="handleRemoveLive"
                                  >
                                    <v-icon color="white">mdi-plus</v-icon>
                                  </v-card>
                                </v-card>
                                <v-tooltip top v-if="errors.removeLiveError">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      class="pl-2"
                                      size="22"
                                      color="red"
                                      v-bind="attrs"
                                      v-on="on"
                                      >mdi-alert</v-icon
                                    >
                                  </template>
                                  <span>{{
                                    $t('message.pages.customizeModal.usedLive')
                                  }}</span>
                                </v-tooltip>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" v-if="errors.removeLiveError">
                          <v-card
                            class="d-flex align-center justify-center pt-3"
                            width="100%"
                            height="20px"
                            flat
                          >
                            <span class="error--text">{{
                              $t('message.pages.customizeModal.liveError2')
                            }}</span>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" v-if="slotLiveAddon.price_id">
                      <v-row no-gutters>
                        <v-col
                          cols="12"
                          class="d-flex flex-row justify-space-between align-center"
                        >
                          <v-row no-gutters>
                            <v-col
                              :cols="isMobileBreakpoint ? '12' : '6'"
                              class="d-flex justify-start px-0"
                            >
                              <span style="line-height: 0"
                                ><span
                                  style="line-height: 130%"
                                  :class="{
                                    blackSubtitle: !$vuetify.theme.dark,
                                  }"
                                  class="customizeItemsText"
                                  >{{
                                    $t(
                                      'message.pages.customizeModal.addonSlotLive'
                                    )
                                  }}</span
                                >
                                <br />
                                <small
                                  >{{
                                    (
                                      slotLiveAddon.unit_amount / 100
                                    ).toLocaleString(currencyLocale, {
                                      style: 'currency',
                                      currency: currency,
                                    })
                                  }}
                                  {{
                                    $t('message.pages.Cart.everySlotOfLive')
                                  }}</small
                                >
                                <br />
                              </span>
                            </v-col>
                            <v-col
                              :cols="isMobileBreakpoint ? '12' : '6'"
                              class="d-flex align-center"
                            >
                              <v-row no-gutters justify="end" align="center">
                                <span
                                  v-if="adicionalSlotLiveAmount > 0"
                                  class="mr-3 cartPlanText primary--text"
                                >
                                  {{ adicionalSlotLiveAmount }}
                                  {{
                                    adicionalSlotLiveAmount > 1
                                      ? 'lives'
                                      : 'live'
                                  }}
                                </span>
                                <v-card
                                  class="d-flex flex-row"
                                  width="74px"
                                  height="32px"
                                  flat
                                >
                                  <v-card
                                    class="d-flex flex-row align-center justify-center"
                                    width="36px"
                                    height="100%"
                                    flat
                                    color="#EBEDFF"
                                    style="
                                      border-top-right-radius: 0px;
                                      border-bottom-right-radius: 0px;
                                      cursor: pointer;
                                    "
                                    @click="handleRemoveSlotLive"
                                  >
                                    <v-icon
                                      :class="{
                                        'v-icon--keep-light':
                                          $vuetify.theme.dark,
                                      }"
                                    >
                                      mdi-minus
                                    </v-icon>
                                  </v-card>
                                  <v-card
                                    class="d-flex flex-row align-center justify-center"
                                    width="36px"
                                    height="100%"
                                    flat
                                    color="primary"
                                    style="
                                      border-top-left-radius: 0px;
                                      border-bottom-left-radius: 0px;
                                      cursor: pointer;
                                    "
                                    @click="handleAddSlotLive"
                                  >
                                    <v-icon color="white">mdi-plus</v-icon>
                                  </v-card>
                                </v-card>
                                <v-tooltip
                                  top
                                  v-if="errors.removeSlotLiveError"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      class="pl-2"
                                      size="22"
                                      color="red"
                                      v-bind="attrs"
                                      v-on="on"
                                      >mdi-alert</v-icon
                                    >
                                  </template>
                                  <span>{{
                                    $t('message.pages.customizeModal.usedLive')
                                  }}</span>
                                </v-tooltip>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-card
                            class="d-flex align-center justify-center pt-3"
                            width="100%"
                            height="20px"
                            flat
                          >
                            <span
                              v-if="errors.removeSlotLiveError"
                              class="error--text"
                              >{{
                                $t(
                                  'message.pages.customizeModal.slotLiveError2'
                                )
                              }}</span
                            >
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" v-if="usersAddon.price_id">
                      <v-divider />
                    </v-col>
                    <v-col cols="12" v-if="usersAddon.price_id">
                      <v-row no-gutters>
                        <v-col
                          cols="12"
                          class="d-flex flex-row justify-space-between align-center"
                        >
                          <v-row no-gutters>
                            <v-col
                              :cols="isMobileBreakpoint ? '12' : '6'"
                              class="d-flex justify-start px-0"
                            >
                              <span style="line-height: 0"
                                ><span
                                  style="line-height: 130%"
                                  :class="{
                                    blackSubtitle: !$vuetify.theme.dark,
                                  }"
                                  class="customizeItemsText"
                                  >{{
                                    $t(
                                      'message.pages.customizeModal.addonUsers'
                                    )
                                  }}</span
                                >
                                <br />
                                <small
                                  >{{
                                    (
                                      usersAddon.unit_amount / 100
                                    ).toLocaleString(currencyLocale, {
                                      style: 'currency',
                                      currency: currency,
                                    })
                                  }}
                                  {{
                                    $t('message.pages.Cart.everyUser')
                                  }}</small
                                >
                                <br />
                                <span>
                                  <small
                                    v-if="
                                      userPlanInfo.addons.slot_user &&
                                      inUseUsers > 0
                                    "
                                  >
                                    {{
                                      $t(
                                        'message.pages.customizeModal.inUsage'
                                      )
                                    }}: {{ inUseUsers }}
                                    {{
                                      inUseUsers > 1
                                        ? $t('message.pages.users.title')
                                        : $t('message.pages.users.table.user')
                                    }}</small
                                  >
                                </span>
                              </span>
                            </v-col>
                            <v-col
                              :cols="isMobileBreakpoint ? '12' : '6'"
                              class="d-flex align-center"
                            >
                              <v-row no-gutters justify="end" align="center">
                                <span
                                  v-if="adicionalUsersAmount > 0"
                                  class="mr-3 cartPlanText primary--text"
                                >
                                  {{ adicionalUsersAmount }}
                                  {{
                                    $t(
                                      'message.pages.users.table.user'
                                    ).toLowerCase()
                                  }}{{ adicionalUsersAmount > 1 ? 's' : '' }}
                                </span>
                                <v-card
                                  class="d-flex flex-row"
                                  width="74px"
                                  height="32px"
                                  flat
                                >
                                  <v-card
                                    class="d-flex flex-row align-center justify-center"
                                    width="36px"
                                    height="100%"
                                    flat
                                    color="#EBEDFF"
                                    style="
                                      border-top-right-radius: 0px;
                                      border-bottom-right-radius: 0px;
                                      cursor: pointer;
                                    "
                                    @click="handleRemoveUser"
                                  >
                                    <v-icon
                                      :class="{
                                        'v-icon--keep-light':
                                          $vuetify.theme.dark,
                                      }"
                                    >
                                      mdi-minus
                                    </v-icon>
                                  </v-card>
                                  <v-card
                                    class="d-flex flex-row align-center justify-center"
                                    width="36px"
                                    height="100%"
                                    flat
                                    color="primary"
                                    style="
                                      border-top-left-radius: 0px;
                                      border-bottom-left-radius: 0px;
                                      cursor: pointer;
                                    "
                                    @click="handleAddUser"
                                  >
                                    <v-icon color="white">mdi-plus</v-icon>
                                  </v-card>
                                </v-card>
                                <v-tooltip top v-if="errors.removeUsersError">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      class="pl-2"
                                      size="22"
                                      color="red"
                                      v-bind="attrs"
                                      v-on="on"
                                      >mdi-alert</v-icon
                                    >
                                  </template>
                                  <span>Error</span>
                                </v-tooltip>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-card
                            class="d-flex align-center justify-center pt-3"
                            width="100%"
                            height="20px"
                            flat
                          >
                            <span
                              v-if="errors.removeUsersError"
                              class="error--text"
                              >{{
                                $t(
                                  'message.pages.customizeModal.slotUsersError'
                                )
                              }}</span
                            >
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                    <template v-if="limitAlertMessage.length">
                      <v-alert
                        v-for="(msg, k) in limitAlertMessage"
                        :key="k"
                        text
                        outlined
                        color="red"
                        icon="mdi-currency-usd"
                      >
                        {{ msg }}
                      </v-alert>
                    </template>
                  </v-col>
                  <v-col
                    cols="12"
                    class="px-2 mb-2"
                    v-if="errors.subscriptionError || errors.unknownError"
                  >
                    <v-card flat height="30">
                      <span class="error--text align-text d-block my-1">
                        <span v-if="errors.unknownError">
                          <v-icon color="error">mdi-alert</v-icon>
                          {{ errors.shownErrMsg }}
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon size="18" v-bind="attrs" v-on="on">
                                mdi-help-circle
                              </v-icon>
                            </template>
                            <v-container
                              class="text-body-2 pa-0"
                              style="max-width: 230px"
                            >
                              {{ errMsg.subscribePlan }}
                            </v-container>
                          </v-tooltip>
                        </span>
                      </span>
                    </v-card>
                  </v-col>
                  <v-col cols="12" class="mt-8 mb-4 ml-5">
                    <p
                      class="text-body-2 neutral--text text--lighten-1 mb-1"
                      v-if="instantPayment"
                    >
                      *{{
                        $t('message.pages.customizeModal.instantPayment', {
                          value: `${payNowValue}`,
                        })
                      }}
                    </p>
                    <v-row no-gutters>
                      <v-col cols="4">
                        <v-btn
                          block
                          color="primary"
                          :loading="isFetchingCheckout"
                          :disabled="
                            isFetchingCheckout ||
                            !somethingChanged ||
                            !paymentSources.length
                          "
                          @click="handlePreCheckout"
                        >
                          {{ $t('message.actions.confirm') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        :cols="isMobileBreakpoint ? '12' : '6'"
        class="px-4 pt-1"
        :style="$vuetify.theme.dark ? '' : 'background-color: #ebedff'"
      >
        <template v-if="errors.prorateError">
          <v-card
            class="d-flex flex-row justify-center align-center"
            height="80%"
            width="100%"
            flat
          >
            <v-row no-gutters>
              <v-col cols="12">
                <v-row no-gutters align="center" justify="center">
                  <v-btn outlined color="primary" @click="handleProhata">
                    {{ $t('message.pages.customizeModal.reloadPreload') }}
                  </v-btn>
                </v-row>
              </v-col>
              <v-col cols="12" class="mt-6">
                <v-row no-gutters align="center" justify="center">
                  <v-alert dense outlined type="error" width="100%">
                    <span>
                      {{
                        errMsg.prorateMsg
                          ? errMsg.prorateMsg
                          : $t(
                              'message.pages.qualitySettings.errors.defaultError'
                            )
                      }}
                      {{ `${$t('message.commom.code')}: ${errCode}` }}
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="pb-1"
                            icon
                            x-small
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon size="18" color="error">
                              mdi-help-circle
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-container
                          class="text-body-2 pa-0"
                          style="max-width: 300px"
                          >{{ errMsg.prorateMsg }}
                        </v-container>
                      </v-tooltip>
                    </span>
                  </v-alert>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </template>
        <template v-else>
          <template v-if="prohataLoading">
            <v-card
              class="d-flex flex-row justify-center align-center"
              height="100%"
              width="100%"
              flat
              :color="$vuetify.theme.dark ? '' : '#EBEDFF'"
            >
              <loading-logo class="ml-8 mb-16" :value="200" />
            </v-card>
          </template>
          <template v-else>
            <v-row no-gutters>
              <v-col v-if="isMobileBreakpoint" cols="12" class="mb-4">
                <v-divider />
              </v-col>
              <v-col cols="12" class="mt-8 mb-4">
                <span class="cartPlanText textType--text">
                  {{ $t('message.paymentDetails') }}
                </span>
              </v-col>
              <v-row no-gutters class="mx-4" v-if="withoutProrateLines.length">
                <v-col cols="12" class="mx-auto py-2 mt-3">
                  <v-row no-gutters>
                    <v-col cols="10">
                      <span class="cartSubPricesText textType--text">
                        ITEM
                      </span>
                    </v-col>
                    <v-col cols="2" class="d-flex justify-end">
                      <span class="cartSubPricesText textType--text">{{
                        $t('message.pages.customizeModal.price').toUpperCase()
                      }}</span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-row
                  no-gutters
                  v-for="(objLine, i) in withoutProrateLines"
                  :key="i"
                  style="width: 100%; line-height: 15px !important"
                  class="py-2"
                >
                  <v-row no-gutters>
                    <v-col class="pr-1">
                      <span
                        class="customizeItemsText textType2--text"
                        style="line-height: 15px !important"
                      >
                        {{ replaceKeywords(objLine.description) }}
                      </span>
                    </v-col>
                    <v-col cols="2" class="d-flex justify-end">
                      <span
                        class="customizeItemsText textType2--text"
                        style="white-space: nowrap"
                      >
                        {{
                          (objLine.amount / 100).toLocaleString(
                            currencyLocale,
                            { style: 'currency', currency: currency }
                          )
                        }}
                      </span>
                    </v-col>
                  </v-row>
                </v-row>
              </v-row>
              <v-col cols="12" class="py-3">
                <v-divider />
              </v-col>
              <v-row no-gutters class="mx-4">
                <!-- <v-col
                  cols="12"
                  class="mx-auto mb-1"
                  v-if="prorateResponse.subtotal && prorateDiscount"
                >
                  <v-row no-gutters justify="space-between">
                    <span class="customizeItemsText textType2--text">
                      Subtotal
                    </span>
                    <span class="customizeItemsText textType2--text"
                      >{{
                        (prorateResponse.subtotal / 100).toLocaleString(
                          currencyLocale,
                          { style: 'currency', currency: currency }
                        )
                      }}
                    </span>
                  </v-row>
                </v-col> -->
                <!-- <template v-if="prorateDiscount">
                  <v-col cols="12" class="mx-auto my-1">
                    <v-row
                      no-gutters
                      v-if="prorateDiscount.coupon.amount_off"
                      justify="space-between"
                    >
                      <span class="customizeItemsText textType2--text">{{
                        `${prorateDiscount.coupon.name} (${(
                          prorateDiscount.coupon.amount_off / 100
                        ).toLocaleString(currencyLocale, {
                          style: 'currency',
                          currency: currency,
                        })} off)`
                      }}</span>
                      <span class="customizeItemsText textType2--text"
                        >-{{
                          (prorateDiscount.amount / 100).toLocaleString(
                            currencyLocale,
                            { style: 'currency', currency: currency }
                          )
                        }}
                      </span>
                    </v-row>
                    <v-row no-gutters v-else justify="space-between">
                      <span class="customizeItemsText textType2--text">{{
                        `${prorateDiscount.coupon.name} (${prorateDiscount.coupon.percent_off}% off)`
                      }}</span>
                      <span class="customizeItemsText textType2--text"
                        >-{{
                          (prorateDiscount.amount / 100).toLocaleString(
                            currencyLocale,
                            { style: 'currency', currency: currency }
                          )
                        }}</span
                      >
                    </v-row>
                  </v-col>
                </template>
                <v-col v-if="prorateDiscount" cols="12" class="mx-auto my-1">
                  <v-row no-gutters justify="space-between">
                    <span class="customizeItemsText textType2--text">
                      Total
                    </span>
                    <span
                      v-if="prorateResponse.total"
                      class="customizeItemsText textType2--text"
                    >
                      {{
                        (prorateResponse.total / 100).toLocaleString(
                          currencyLocale,
                          { style: 'currency', currency: currency }
                        )
                      }}
                    </span>
                    <span v-else class="customizeItemsText textType2--text">
                      {{
                        (0).toLocaleString(currencyLocale, {
                          style: 'currency',
                          currency: currency,
                        })
                      }}
                    </span>
                  </v-row>
                </v-col> -->
                <v-col
                  cols="12"
                  class="mx-auto my-1"
                  v-if="prorateResponse.amount_due"
                >
                  <v-row no-gutters justify="space-between">
                    <span class="customizeItemsText textType2--text">
                      {{ $t('message.pages.customizeModal.finalValue') }}
                    </span>
                    <span class="customizeItemsText textType2--text"
                      >{{
                        sumCycleValues(withoutProrateLines).toLocaleString(
                          currencyLocale,
                          {
                            style: 'currency',
                            currency: currency,
                          }
                        )
                      }}
                    </span>
                  </v-row>
                </v-col>
              </v-row>
              <v-col cols="12" class="mt-6">
                <v-card
                  width="100%"
                  class="elevation-0 px-6"
                  color="newBackground"
                >
                  <v-card
                    v-if="prohataObjects.length > 1"
                    height="79px"
                    width="100%"
                    color="newBackground"
                    flat
                  >
                    <v-row
                      no-gutters
                      justify="center"
                      align="center"
                      class="fill-height"
                    >
                      <v-col cols="12">
                        <v-row no-gutters>
                          <v-col cols="7">
                            <span class="cartBenefitsText typeText2--text mr-2">
                              <b>{{
                                $t('message.pages.customizeModal.actualCycle')
                              }}</b>
                            </span>
                            <span
                              class="customizeItemsText primary--text"
                              style="cursor: pointer"
                              @click="handleMoreDetails"
                            >
                              <b
                                >+
                                {{
                                  $t('message.pages.customizeModal.details')
                                }}</b
                              >
                            </span>
                          </v-col>
                          <v-col cols="5" class="d-flex justify-end">
                            <span class="cartBenefitsText primary--text">
                              {{
                                (
                                  prorateResponse.amount_due / 100
                                ).toLocaleString(currencyLocale, {
                                  style: 'currency',
                                  currency: currency,
                                })
                              }}
                            </span>
                          </v-col>
                          <v-col cols="7">
                            <span class="customizeItemsText">
                              {{ $t('message.pages.customizeModal.expiry') }}
                              {{ getPayDate }}
                            </span>
                          </v-col>
                          <v-col cols="5" class="d-flex justify-end">
                            <span class="customizeItemsText">
                              {{
                                $t(
                                  'message.pages.customizeModal.proporcionalValue'
                                )
                              }}
                            </span>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card height="79px" width="100%" color="newBackground" flat>
                    <v-row
                      no-gutters
                      justify="center"
                      align="center"
                      class="fill-height"
                      :class="prorateDiscount ? 'pt-5' : ''"
                    >
                      <v-col cols="7">
                        <span class="cartBenefitsText typeText2--text">
                          <b
                            >{{ $t('message.pages.customizeModal.nextCycles') }}
                          </b>
                        </span>
                      </v-col>
                      <v-col cols="5" class="d-flex justify-end">
                        <span class="cartBenefitsText primary--text">
                          {{
                            sumCycleValues(withoutProrateLines).toLocaleString(
                              currencyLocale,
                              {
                                style: 'currency',
                                currency: currency,
                              }
                            )
                          }}/{{ $t('message.month') }}
                        </span>
                      </v-col>
                      <v-col
                        v-if="prorateDiscount"
                        cols="12"
                        style="height: 24px !important"
                      >
                        <span class="caption">
                          *{{ $t('message.pages.customizeModal.noDiscount') }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card
                    v-if="instantPayment"
                    height="79px"
                    width="100%"
                    color="newBackground"
                    flat
                  >
                    <v-row
                      no-gutters
                      justify="center"
                      align="center"
                      class="fill-height"
                    >
                      <v-col cols="12">
                        <v-row no-gutters>
                          <v-col cols="7">
                            <span class="cartBenefitsText typeText2--text mr-2">
                              <b>{{ $t('message.payNow') }}</b>
                            </span>
                          </v-col>
                          <v-col cols="5" class="d-flex justify-end">
                            <span class="cartBenefitsText primary--text">
                              <!-- {{
                              (
                                prorateResponse.amount_due / 100
                              ).toLocaleString(currencyLocale, {
                                style: 'currency',
                                currency: currency,
                              })
                            }} -->
                              *{{ payNowValue }}
                            </span>
                          </v-col>
                          <v-col cols="7">
                            <span
                              class="customizeItemsText white--text"
                              :class="{
                                'neutral--text': !$vuetify.theme.dark,
                              }"
                            >
                              {{
                                this.adicionalStorageAmount >= 2048
                                  ? $t(
                                      'message.pages.customizeModal.additionalStorage'
                                    )
                                  : ''
                              }}{{
                                this.adicionalStorageAmount >= 2048 &&
                                this.adicionalTrafficAmount >= 2048
                                  ? ', '
                                  : ''
                              }}
                              {{
                                this.adicionalTrafficAmount >= 2048
                                  ? $t(
                                      'message.pages.customizeModal.additionalTraffic'
                                    )
                                  : ''
                              }}
                            </span>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-card>
              </v-col>
              <v-col cols="12" class="mt-4">
                <v-card
                  width="100%"
                  class="elevation-0 px-6"
                  color="newBackground"
                >
                  <v-card height="79px" width="100%" color="newBackground" flat>
                    <v-row
                      no-gutters
                      justify="center"
                      align="center"
                      class="fill-height"
                    >
                      <v-col cols="8">
                        <span class="cartBenefitsText typeText2--text">
                          <v-row no-gutters>
                            <template
                              v-if="defaultSource && defaultSource.type"
                            >
                              <template v-if="defaultSource.type === 'boleto'">
                                <v-card
                                  style="padding-left: 2px"
                                  outlined
                                  width="35"
                                  height="24"
                                  class="rounded card-image d-flex align-center justify-center"
                                >
                                  <v-img
                                    src="@/assets/boletoIcon.svg"
                                    max-width="24"
                                  />
                                </v-card>
                                <span class="pl-2">
                                  {{ $t('message.pages.userPlan.ticket') }}
                                </span>
                              </template>
                              <template v-else>
                                <img
                                  :src="
                                    cardsImages[
                                      `${defaultSource.brand.toLowerCase()}`
                                    ]
                                  "
                                  width="35"
                                  class="rounded card-image"
                                />
                                <span class="pl-2">
                                  {{
                                    capitalizeFirstLetter(defaultSource.brand)
                                  }}-{{ defaultSource.last4 }}
                                </span>
                              </template>
                            </template>
                            <template v-else>
                              {{ $t('message.pages.userPlan.noPaymentMethod') }}
                            </template>
                          </v-row>
                        </span>
                      </v-col>
                      <v-col cols="4" class="d-flex justify-end">
                        <span
                          class="cartBenefitsText primary--text"
                          style="cursor: pointer"
                          @click="handleChangeCard"
                        >
                          {{ $t('message.actions.change') }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-card>
              </v-col>
              <v-col cols="12" class="mt-6">
                <span
                  class="customizeWarnText"
                  v-html="$t('message.pages.customizeModal.warnMessage')"
                ></span>
              </v-col>
            </v-row>
          </template>
        </template>
      </v-col>
    </v-row>
    <CustomizePlanDetailsFirst />
    <CustomizePlanConfirmModal
      :prohataObjects="prohataObjects"
      :prorateResponse="prorateResponse"
      :getPayDate="payDate"
      :userCurrency="userPlanInfo.currency"
      :paymentSources="paymentSources"
      :defaultSource="defaultSource"
      :cardsImages="cardsImages"
      :openConfirmModal="openConfirmModal"
      :isFetchingCheckout="isFetchingCheckout"
    >
    </CustomizePlanConfirmModal>
    <instantPaymentWarnModal
      :defaultSource="defaultSource"
      @confirm="true"
      :value="payNowValue"
    />
  </v-card>
</template>

<script>
// external imports
import { mapMutations, mapState, mapActions } from 'vuex'
import prettyBytes from 'pretty-bytes'
import _ from 'lodash'

// internal imports
import calcMegabytesMixin from '@/utils/calcMegabytes.js'
import linkHelper from '@/utils/linkHelper.mixin.js'
import i18n from '@/translations/lang'

// API
import planApi from '@/services/planApi'
import subUsersManagement from '@/services/subUsersManagement'

// Components
import instantPaymentWarnModal from './instantPaymentWarnModal.vue'
import LoadingLogo from '@/components/LoadingLogo.vue'
import CustomizePlanDetailsFirst from '@/components/CustomizePlanDetailsFirst.vue'
import CustomizePlanConfirmModal from '@/components/CustomizePlanConfirmModal.vue'

export default {
  name: 'CustomizePlan',
  components: {
    LoadingLogo,
    CustomizePlanDetailsFirst,
    CustomizePlanConfirmModal,
    instantPaymentWarnModal,
  },
  props: {
    plan: Object,
    noPlanChange: Boolean,
  },
  mixins: [calcMegabytesMixin, linkHelper],
  data: () => ({
    isFetching: false,
    isFetchingCheckout: false,
    prohataLoading: false,
    prorateLines: [],
    adicionalStorageAmount: 0,
    adicionalTrafficAmount: 0,
    adicionalLiveAmount: 0,
    adicionalSlotLiveAmount: 0,
    adicionalUsersAmount: 0,
    transformUsageStorage: 512,
    transformUsageTraffic: 512,
    transformUsageLive: 60,
    transformUsageSlotLive: 1,
    transformUsageUsers: 1,
    storageAddon: {},
    trafficAddon: {},
    liveAddon: {},
    slotLiveAddon: {},
    usersAddon: {},
    posPaidTrafficAddon: {},
    posPaidLiveAddon: {},
    posPaidSlotLiveAddon: {},
    errors: {
      removeRealtimeError: false,
      subscriptionError: false,
      addonsError: false,
      removeStorageError: false,
      removeTrafficError: false,
      removeLiveError: false,
      removeSlotLiveError: false,
      removeUsersError: false,
      prorateError: false,
      unknownError: false,
      shownErrMsg: '',
      errMsg: i18n.t('message.errors.unexpectedError'),
    },
    errMsg: {
      subscribePlan: '',
      prohataError: '',
      prorateMsg: '',
    },
    prohataRequestTimeout: null,
    prorateResponse: {},
    prohataObjects: [],
    prorateDiscount: null,
    initialAddonsAmount: {
      storage: 0,
      traffic: 0,
      live: 0,
      slotLive: 0,
      users: 0,
    },
    stripeMenuUrl: '',
    oldInfo: {
      adicionalStorageAmount: 0,
      adicionalTrafficAmount: 0,
      adicionalLiveAmount: 0,
      adicionalSlotLiveAmount: 0,
      adicionalUsersAmount: 0,
    },
    currency: 'brl',
    currencyLocale: 'pt-BR',
    isBeta: false,
    fetchUsers: true,
    inUseUsers: 0,
    defaultSource: null,
    cardsImages: {
      mastercard:
        'https://js.stripe.com/v3/fingerprinted/img/mastercard-4d8844094130711885b5e41b28c9848f.svg',
      visa: 'https://js.stripe.com/v3/fingerprinted/img/visa-729c05c240c4bdb47b03ac81d9945bfe.svg',
      elo: 'https://js.stripe.com/v3/fingerprinted/img/elo-efe873e884e6c9eb817f23a120caaa3e.svg',
      american_express:
        'https://js.stripe.com/v3/fingerprinted/img/elo-efe873e884e6c9eb817f23a120caaa3e.svg',
    },
    hasCompletedPurchase: false,
    withoutProrateLines: [],
    paymentSources: [],
    payDate: '',
    openConfirmModal: false,
    userData: {},
  }),
  computed: {
    ...mapState({
      products: (state) => state.user.products,
      userPlanInfo: (state) => state.user.userPlanInfo,
      isJustFewCustomizing: (state) => state.user.justFewCustomizing,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    payNowValue() {
      if (this.prohataObjects.length > 1) {
        return (this.prorateResponse.amount_due / 100).toLocaleString(
          this.currencyLocale,
          {
            style: 'currency',
            currency: this.currency,
          }
        )
      }
      return this.sumCycleValues(this.withoutProrateLines).toLocaleString(
        this.currencyLocale,
        {
          style: 'currency',
          currency: this.currency,
        }
      )
    },
    instantPayment() {
      const isNewbie = this.isAccountRecent()
      return (
        (this.adicionalTrafficAmount >= 2048 ||
          this.adicionalStorageAmount >= 2048) &&
        isNewbie
      )
    },
    currencySymbol() {
      if (this.currency === 'brl') return 'R$'
      return '$'
    },
    limitAlertMessage() {
      let msg = []
      if (this.isCurrentBandwidthOut && this.isCurrentStorageOut) {
        msg.push(this.$i18next.t('message.pages.Cart.alerts.both'))
      } else {
        if (this.isCurrentStorageOut) {
          msg.push(this.$i18next.t('message.pages.Cart.alerts.storage'))
        }
        if (this.isCurrentBandwidthOut) {
          msg.push(this.$i18next.t('message.pages.Cart.alerts.bandwidth'))
        }
      }

      return msg
    },
    isCurrentStorageOut() {
      /*const { metadata } = this.products.plans.filter(
        ({ name }) => name === this.userPlanInfo.subscription.name
      )[0]

      const planStorage = Number(metadata.storage) * 1024
      const currentStorage = this.userPlanInfo.limit.storage
      const limitStorage = planStorage + this.adicionalStorageAmount * 1024

      return limitStorage < currentStorage*/
      return false
    },
    isCurrentBandwidthOut() {
      /*const { metadata } = this.products.plans.filter(
        ({ name }) => name === this.userPlanInfo.subscription.name
      )[0]

      const planTraffic = Number(metadata.transfer) * 1024
      const currentTraffic = this.userPlanInfo.limit.traffic
      const limitTraffic = planTraffic + this.adicionalTrafficAmount * 1024

      return limitTraffic < currentTraffic*/
      return false
    },
    firstStepStyle() {
      if (this.isMobileBreakpoint) return ''
      return this.$vuetify.theme.dark
        ? 'border-right: 1px solid #262726;'
        : 'border-right: 1px solid rgba(0, 0, 0, 0.12);'
    },
    trafficLink() {
      return this.getTrafficLink()
    },
    getPayDate() {
      return this.getDateThroughTimeStamp(this.getPayTimeStamp)
    },
    getPayTimeStamp() {
      if (this.prohataObjects[this.prohataObjects.length - 1].end) {
        return this.prohataObjects[this.prohataObjects.length - 1].end
      }
      if (
        !this.prorateResponse.next_payment_attempt &&
        this.prorateResponse.lines
      ) {
        return this.prorateResponse.period.end
      } else {
        return this.prorateResponse.next_payment_attempt
      }
    },
    somethingChanged() {
      return (
        !this.noPlanChange ||
        this.oldInfo.adicionalStorageAmount != this.adicionalStorageAmount ||
        this.oldInfo.adicionalTrafficAmount != this.adicionalTrafficAmount ||
        this.oldInfo.adicionalLiveAmount != this.adicionalLiveAmount ||
        this.oldInfo.adicionalSlotLiveAmount != this.adicionalSlotLiveAmount ||
        this.oldInfo.adicionalUsersAmount != this.adicionalUsersAmount
      )
    },
    addonsPrice() {
      return (
        this.aditionalStoragePrice +
        this.aditionalTrafficPrice +
        this.aditionalLivePrice +
        this.aditionalSlotLivePrice +
        this.aditionalUsersPrice
      )
    },
    allProhataLinesPrice() {
      let arrayOfValues = this.prorateLines.map((line) => line.amount / 100)
      const sumOfLines = arrayOfValues.reduce(
        (partial_sum, a) => partial_sum + a,
        0
      )
      return `${sumOfLines.toLocaleString(this.currencyLocale, {
        style: 'currency',
        currency: this.currency,
      })}`
    },
    aditionalStoragePrice() {
      if (this.adicionalStorageAmount < 99) return 0
      let value = this.eachStorageAddonPrice * this.adicionalStorageAmount
      if (this.storageAddon?.transform_usage?.divide_by) {
        value = value / this.transformUsageStorage
      }
      return value
    },
    aditionalTrafficPrice() {
      if (this.adicionalTrafficAmount < 99) return 0
      let value = this.eachTrafficAddonPrice * this.adicionalTrafficAmount
      if (this.trafficAddon?.transform_usage?.divide_by) {
        value = value / this.transformUsageTraffic
      }
      return value
    },
    aditionalLivePrice() {
      if (this.adicionalLiveAmount < 1) return 0
      let value = this.adicionalLiveAmount * (this.liveAddon?.unit_amount / 100)
      return value
    },
    aditionalSlotLivePrice() {
      if (this.adicionalSlotLiveAmount < 1) return 0
      let value =
        this.adicionalSlotLiveAmount * (this.slotLiveAddon?.unit_amount / 100)
      return value
    },
    aditionalUsersPrice() {
      if (this.adicionalUsersAmount < 1) return 0
      let value =
        this.adicionalUsersAmount * (this.usersAddon?.unit_amount / 100)
      return value
    },
    eachStorageAddonPrice() {
      return this.storageAddon.unit_amount / 100
    },
    eachTrafficAddonPrice() {
      return this.trafficAddon.unit_amount / 100
    },
    fixedAddonAmount() {
      if (this.adicionalStorageAmount < 1) {
        return 0
      }
      return `${this.calcMegabytes(
        this.adicionalStorageAmount,
        'GB',
        'TB',
        true
      )}`
    },
    fixedTrafficAmount() {
      if (this.adicionalTrafficAmount < 1) {
        return 0
      }
      return `${this.calcMegabytes(
        this.adicionalTrafficAmount,
        'GB',
        'TB',
        true
      )}`
    },
    finalPrice() {
      return `${(
        parseFloat(this.plan.price) + parseFloat(this.addonsPrice)
      ).toLocaleString(this.currencyLocale, {
        style: 'currency',
        currency: this.currency,
      })}`
    },
    isUserTrialing() {
      return this.userPlanInfo?.subscription?.status === 'trialing'
    },
    trialDays() {
      const timeDifference =
        new Date(this.userPlanInfo?.subscription?.trial_end * 1000).getTime() -
        new Date().getTime()
      const daysDifference = (timeDifference / (1000 * 3600 * 24)).toFixed(0)
      return daysDifference
    },
  },
  created() {
    this.getUserData()
  },
  watch: {
    addonsPrice() {
      this.prohataRequestTimeout && clearTimeout(this.prohataRequestTimeout)
      this.prohataRequestTimeout = setTimeout(() => {
        this.handleProhata()
      }, 1000)
    },
  },
  async mounted() {
    this.isBeta = location.search.match('beta')
    this.setCurrencyConfig()
    this.getCards()
    this.getUsers()
    if (this.userPlanInfo.subscription !== null) {
      let userAddons = this.userPlanInfo.addons
      if (userAddons.storage) {
        let prePlan = this.userPlanInfo.addons.storage.find(
          (el) => el.charge === 'pre'
        )
        if (prePlan) {
          this.adicionalStorageAmount = prePlan.quantity
          this.initialAddonsAmount.storage = prePlan.quantity
          this.storageAddon = prePlan
          if (this.storageAddon.transform_usage.divide_by)
            this.transformUsageStorage =
              this.storageAddon.transform_usage.divide_by
        }
      }
      if (userAddons.traffic) {
        let prePlan = this.userPlanInfo.addons.traffic.find(
          (el) => el.charge === 'pre'
        )
        if (prePlan) {
          this.adicionalTrafficAmount = prePlan.quantity
          this.initialAddonsAmount.traffic = prePlan.quantity
          this.trafficAddon = prePlan
          if (this.trafficAddon.transform_usage.divide_by)
            this.transformUsageStorage =
              this.trafficAddon.transform_usage.divide_by
        }
      }
      if (userAddons.live) {
        let prePlan = this.userPlanInfo.addons.live.find(
          (el) => el.charge === 'pre'
        )
        if (prePlan) {
          this.adicionalLiveAmount = prePlan.quantity
          this.initialAddonsAmount.live = prePlan.quantity
          this.liveAddon = prePlan
          if (this.liveAddon.transform_usage.divide_by)
            this.transformUsageStorage =
              this.liveAddon.transform_usage.divide_by
        }
      }
      if (userAddons.slot_live) {
        let prePlan = this.userPlanInfo.addons.slot_live.find(
          (el) => el.charge === 'pre'
        )
        if (prePlan) {
          this.adicionalSlotLiveAmount = prePlan.quantity
          this.initialAddonsAmount.slotLive = prePlan.quantity
          this.slotLiveAddon = prePlan
          if (this.slotLiveAddon.transform_usage.divide_by)
            this.transformUsageSlotLive =
              this.slotLiveAddon.transform_usage.divide_by
        }
      }
      if (userAddons.slot_user) {
        let prePlan = this.userPlanInfo.addons.slot_user.find(
          (el) => el.charge === 'pre'
        )
        if (prePlan) {
          this.adicionalUsersAmount = prePlan.quantity
          this.initialAddonsAmount.users = prePlan.quantity
          this.usersAddon = prePlan
          if (this.usersAddon.transform_usage.divide_by)
            this.transformUsageSlotLive =
              this.usersAddon.transform_usage.divide_by
        }
      }
    }
    this.addons = this.products.addons
    for (let i = 0; i < this.addons.length; i++) {
      let addon = this.addons[i]
      if (
        addon.metadata.type === 'storage' &&
        addon.metadata.charge === 'pre' &&
        this.initialAddonsAmount.storage < 1
      ) {
        this.storageAddon = addon.prices[0]
      }
      if (
        addon.metadata.type === 'traffic' &&
        addon.metadata.charge === 'pre' &&
        this.initialAddonsAmount.traffic < 1
      ) {
        this.trafficAddon = addon.prices[0]
      }
      if (
        addon.metadata.type === 'live' &&
        addon.metadata.charge === 'pre' &&
        this.initialAddonsAmount.live < 1
      ) {
        this.liveAddon = addon.prices[0]
      }
      if (
        addon.metadata.type === 'traffic' &&
        addon.metadata.charge === 'pos'
      ) {
        const found = _.find(this.userPlanInfo.addons.traffic, {
          charge: 'pos',
          type: 'traffic',
        })

        this.posPaidTrafficAddon = found ?? addon.prices[0]
      }
      if (addon.metadata.type === 'live' && addon.metadata.charge === 'pos') {
        this.posPaidLiveAddon = addon.prices[0]
      }
      if (addon.metadata.type === 'slot_live') {
        this.slotLiveAddon = addon.prices[0]
      }
      if (addon.metadata.type === 'slot_user') {
        this.usersAddon = addon.prices[0]
      }
    }
    this.setInitialValues()
    clearTimeout(this.prohataRequestTimeout)
    await Promise.all([this.handleProhata(), this.handleStripeSettings()])

    this.$root.$on('CloseConfirmModal', (val) => (this.openConfirmModal = val))

    this.$root.$on('handleCheckout', () => {
      this.handleCheckout()
    })
  },
  beforeDestroy() {
    this.$root.$off('CloseConfirmModal')
    this.$root.$off('handleCheckout')
  },
  methods: {
    ...mapActions('session', ['getUserDataByID']),
    ...mapMutations('user', ['UPDATE_ONLY_CUSTOMIZING']),
    sumCycleValues(cycleLines) {
      const sum = cycleLines.reduce((acc, line) => acc + line.amount, 0)
      return sum / 100
    },
    replaceKeywords(description) {
      if (
        (description.includes('Live Adicional') &&
          description.includes('(Pós)')) ||
        (description.includes('Additional live') &&
          description.includes('(Post)'))
      ) {
        description = description.replace(/\bmês\b|\bmonth\b/g, 'min')
      }
      return description
    },
    async getCards() {
      try {
        const { data } = await planApi.getCards()
        const card = data.sources.find((item) => item.default === true)
        this.paymentSources = data.sources
        this.defaultSource = card
      } catch (error) {
        console.error('error', error)
      }
    },
    async getUsers() {
      this.fetchUsers = true
      try {
        let ret = await subUsersManagement.getAllsubUsers()
        this.inUseUsers = ret.data.length - 1
        this.fetchUsers = false
      } catch (e) {
        this.fetchUsers = false
        console.log('e', e)
      }
    },
    isCurrentMonth({ end }) {
      const dateObject = new Date(end * 1000)
      return (
        dateObject.getMonth() ===
        new Date(this.getPayTimeStamp * 1000).getMonth()
      )
    },
    isNextMonth({ end }) {
      const dateObject = new Date(end * 1000)
      return (
        dateObject.getMonth() ===
        new Date(this.getPayTimeStamp * 1000).getMonth() + 1
      )
    },
    getProhataLabel({ end }) {
      if (this.isCurrentMonth({ end })) return 'current'
      if (this.isNextMonth({ end })) return 'next'
      return false
    },
    isGoldOrSilver() {
      if (['Gold', 'Silver'].includes(this.plan.title)) {
        return true
      } else {
        return false
      }
    },
    getDateThroughTimeStamp(date) {
      let locale = this.getLocale()
      let options = {
        month: '2-digit',
        year: '2-digit',
        day: '2-digit',
      }
      this.payDate = String(
        new Date(date * 1000).toLocaleString(locale, options).slice(0, 3) +
          new Date(date * 1000).toLocaleString(locale, options).slice(3, 6) +
          new Date(date * 1000).toLocaleString(locale, options).slice(6, 10)
      )
      return String(
        new Date(date * 1000).toLocaleString(locale, options).slice(0, 3) +
          new Date(date * 1000).toLocaleString(locale, options).slice(3, 6) +
          new Date(date * 1000).toLocaleString(locale, options).slice(6, 10)
      )
    },
    checkIfHasCoupon(productId) {
      if (!this.prorateDiscount) return false
      if (this.prorateDiscount.applies_to) {
        let hasDiscount =
          this.prorateDiscount.applies_to.products.includes(productId)
        return hasDiscount
      }
    },
    setInitialValues() {
      this.oldInfo = {
        adicionalStorageAmount: this.adicionalStorageAmount,
        adicionalTrafficAmount: this.adicionalTrafficAmount,
        adicionalLiveAmount: this.adicionalLiveAmount,
        adicionalSlotLiveAmount: this.adicionalSlotLiveAmount,
        adicionalUsersAmount: this.adicionalUsersAmount,
      }
    },
    handleBackPlans() {
      this.$root.$emit('getBackToPlans')
    },
    handleGoToCheckout() {
      this.$root.$emit('finishAddons')
    },
    handleAddStorage() {
      this.errors.removeStorageError = false
      if (this.adicionalStorageAmount > 512000) return
      this.adicionalStorageAmount += this.transformUsageStorage
    },
    handleRemoveStorage() {
      if (this.userPlanInfo.subscription) {
        if (
          (this.userPlanInfo.subscription.metadata.storage +
            this.adicionalStorageAmount) *
            1000 >
          this.userPlanInfo.limit.storage
        ) {
          if (this.adicionalStorageAmount > 99)
            this.adicionalStorageAmount -= this.transformUsageStorage
        } else {
          this.errors.removeStorageError = true
        }
      } else {
        if (this.adicionalStorageAmount >= this.transformUsageStorage) {
          this.adicionalStorageAmount -= this.transformUsageStorage
        } else {
          this.adicionalStorageAmount = 0
        }
      }
    },
    handleAddTraffic() {
      this.errors.removeTrafficError = false
      if (this.adicionalTrafficAmount > 512000) return
      this.adicionalTrafficAmount += this.transformUsageTraffic
    },
    handleRemoveTraffic() {
      if (this.userPlanInfo.subscription) {
        if (
          (this.userPlanInfo.subscription.metadata.transfer +
            this.adicionalTrafficAmount) *
            1000 >
          this.userPlanInfo.limit.traffic
        ) {
          if (this.adicionalTrafficAmount > 99)
            this.adicionalTrafficAmount -= this.transformUsageTraffic
        } else {
          this.errors.removeTrafficError = true
        }
      } else {
        if (this.adicionalTrafficAmount >= this.transformUsageTraffic) {
          this.adicionalTrafficAmount -= this.transformUsageTraffic
        } else {
          this.adicionalTrafficAmount = 0
        }
      }
    },
    handleAddLive() {
      this.errors.removeLiveError = false
      if (this.adicionalLiveAmount > 99999) return
      this.adicionalLiveAmount += 60
    },
    handleRemoveLive() {
      if (this.adicionalLiveAmount > 1) this.adicionalLiveAmount -= 60
    },
    handleAddSlotLive() {
      this.errors.removeSlotLiveError = false
      if (this.adicionalSlotLiveAmount > 99999) return
      this.adicionalSlotLiveAmount += 1
    },
    handleRemoveSlotLive() {
      if (this.adicionalSlotLiveAmount >= 1) this.adicionalSlotLiveAmount -= 1
    },
    handleAddUser() {
      this.errors.removeUsersError = false
      if (this.adicionalUsersAmount > 99999) return
      this.adicionalUsersAmount += 1
    },
    handleRemoveUser() {
      if (this.adicionalUsersAmount >= 1) this.adicionalUsersAmount -= 1
    },
    handleBackToPlans() {
      this.$root.$emit('getBackToPlans')
    },
    async getUserData() {
      const { data } = await this.getUserDataByID()
      this.userData = data
    },

    isAccountRecent() {
      const accountCreatedAt = new Date(this.userData.created_at)

      const currentDate = new Date()

      const timeDifference = currentDate - accountCreatedAt
      const monthsDifference = timeDifference / (1000 * 60 * 60 * 24 * 30.44)

      return monthsDifference < 2
    },
    handleOpenWarningModal() {
      this.$root.$emit('openInstantPaymentWarnModal')
    },
    handlePreCheckout() {
      if (this.instantPayment) {
        this.handleOpenWarningModal()
      } else {
        this.handleCheckout()
      }
    },
    async handleCheckout() {
      clearTimeout(this.prohataRequestTimeout)
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
      this.isFetchingCheckout = true
      if (!this.noPlanChange) {
        let changePlanResponse = await this.subscribeToPlan()
        if (!changePlanResponse) return
      }
      if (this.errors.subscriptionError) {
        return
      }
      await this.subscribeUserToAddons()
      this.$router.push({ name: 'Videos' })
      this.$root.$emit('openCheckoutDoneModal')
      // this.hasCompletedPurchase = true
      this.$root.$emit('refreshUserPlan')
      this.isFetchingCheckout = false
    },
    async subscribeToPlan() {
      try {
        const ret = await planApi.subscribeToPlan(this.plan.title.toLowerCase())
        return ret
      } catch (e) {
        this.isFetchingCheckout = false
        const error = e?.response?.data
        if (
          error?.info?.type === 'block_downgrade' &&
          error?.info?.reason === 'users'
        ) {
          const info = error.info
          let exceededUsers = Math.abs(
            Number(this.plan.users) +
              info.current_additional_slots -
              info.current_users
          )
          this.errors.unknownError = true
          this.errors.shownErrMsg = i18n.t(
            'message.pages.customizeModal.deleteUserError',
            {
              count: exceededUsers,
            }
          )
          return
        }
        this.handleFetchError(e)
        return false
      }
    },
    handleFetchError(err) {
      this.errors.unknownError = true
      this.errors.subscriptionError = true
      this.errMsg.subscribePlan =
        err.msg ??
        err.response.data.errMsg ??
        err.response.data.message ??
        'Error'
      this.errors.shownErrMsg = i18n.t('message.errors.unexpectedError')
    },
    async subscribeUserToAddons() {
      let items = []
      if (this.oldInfo.adicionalStorageAmount != this.adicionalStorageAmount) {
        items.push({
          type: 'storage',
          quantity: Math.round(this.adicionalStorageAmount),
        })
      }
      if (this.oldInfo.adicionalTrafficAmount != this.adicionalTrafficAmount) {
        items.push({
          type: 'traffic',
          quantity: Math.round(this.adicionalTrafficAmount),
        })
      }
      if (this.oldInfo.adicionalLiveAmount != this.adicionalLiveAmount) {
        items.push({
          type: 'live',
          quantity: Math.round(this.adicionalLiveAmount),
        })
      }
      if (
        this.oldInfo.adicionalSlotLiveAmount != this.adicionalSlotLiveAmount
      ) {
        items.push({
          type: 'slot_live',
          quantity: Math.round(this.adicionalSlotLiveAmount),
        })
      }
      if (this.oldInfo.adicionalUsersAmount != this.adicionalUsersAmount) {
        items.push({
          type: 'slot_user',
          quantity: Math.round(this.adicionalUsersAmount),
        })
      }
      for (let i = 0; i < items.length; i++) {
        let userAddon = items[i]
        try {
          await planApi.setAddon(userAddon)
        } catch (e) {
          this.isFetchingCheckout = false
          console.error(e)
        }
      }
    },
    setCurrencyConfig() {
      const currency = this.userPlanInfo.currency
      if (currency === 'usd') {
        this.currency = 'usd'
        this.currencyLocale = 'en-US'
        return
      } else {
        this.currency = 'brl'
        this.currencyLocale = 'pt-BR'
      }
    },
    getLocale() {
      if (this.$i18next.resolvedLanguage === 'en') return 'en-US'
      return 'pt-BR'
    },
    async handleProhata() {
      this.prohataLoading = true
      this.errors.prorateError = false
      try {
        let items = []
        if (!this.noPlanChange) {
          items.push({ price: this.plan.prices[0].id, quantity: 1 })
          if (this.userPlanInfo.subscription_id) {
            items.push({
              id: this.userPlanInfo.subscription.subscription_item,
              deleted: true,
            })
          }
        }
        if (this.adicionalStorageAmount > 1) {
          let storageAddonItem = {
            quantity: Math.round(this.adicionalStorageAmount),
          }
          if (this.userPlanInfo?.addons?.storage) {
            let prePlan = this.userPlanInfo.addons.storage.find(
              (el) => el.charge === 'pre'
            )
            if (prePlan) {
              storageAddonItem.id = prePlan.subscription_item
            } else {
              storageAddonItem.price = this.storageAddon.id
            }
          } else {
            storageAddonItem.price = this.storageAddon.id
          }
          items.push(storageAddonItem)
        } else {
          if (this.initialAddonsAmount.storage > 1) {
            let prePlan = this.userPlanInfo.addons.storage.find(
              (el) => el.charge === 'pre'
            )
            items.push({
              id: prePlan.subscription_item,
              deleted: true,
            })
          }
        }
        if (this.adicionalTrafficAmount > 1) {
          let trafficAddonItem = {
            quantity: Math.round(this.adicionalTrafficAmount),
          }
          if (this.userPlanInfo?.addons?.traffic) {
            let prePlan = this.userPlanInfo.addons.traffic.find(
              (el) => el.charge === 'pre'
            )
            if (prePlan) {
              trafficAddonItem.id = prePlan.subscription_item
            } else {
              trafficAddonItem.price = this.trafficAddon.id
            }
          } else {
            trafficAddonItem.price = this.trafficAddon.id
          }
          items.push(trafficAddonItem)
        } else {
          if (this.initialAddonsAmount.traffic > 1) {
            let prePlan = this.userPlanInfo.addons.traffic.find(
              (el) => el.charge === 'pre'
            )
            items.push({
              id: prePlan.subscription_item,
              deleted: true,
            })
          }
        }
        if (this.adicionalLiveAmount > 1) {
          let liveAddonItem = {
            quantity: this.adicionalLiveAmount,
          }
          if (this.userPlanInfo?.addons?.live) {
            let prePlan = this.userPlanInfo.addons.live.find(
              (el) => el.charge === 'pre'
            )
            if (prePlan) {
              liveAddonItem.id = prePlan.subscription_item
            } else {
              liveAddonItem.price = this.liveAddon.id
            }
          } else {
            liveAddonItem.price = this.liveAddon.id
          }
          items.push(liveAddonItem)
        } else {
          if (this.initialAddonsAmount.live > 1) {
            let prePlan = this.userPlanInfo.addons.live.find(
              (el) => el.charge === 'pre'
            )
            items.push({
              id: prePlan.subscription_item,
              deleted: true,
            })
          }
        }
        if (this.adicionalSlotLiveAmount >= 1) {
          let slotLiveAddonItem = {
            quantity: this.adicionalSlotLiveAmount,
          }
          if (this.userPlanInfo?.addons?.slot_live) {
            let prePlan = this.userPlanInfo.addons.slot_live.find(
              (el) => el.charge === 'pre'
            )
            if (prePlan) {
              slotLiveAddonItem.id = prePlan.subscription_item
            } else {
              slotLiveAddonItem.price = this.slotLiveAddon.id
            }
          } else {
            slotLiveAddonItem.price = this.slotLiveAddon.id
          }
          items.push(slotLiveAddonItem)
        } else {
          if (this.initialAddonsAmount.slotLive >= 1) {
            let prePlan = this.userPlanInfo.addons.slot_live.find(
              (el) => el.charge === 'pre'
            )
            items.push({
              id: prePlan.subscription_item,
              deleted: true,
            })
          }
        }
        if (this.adicionalUsersAmount >= 1) {
          let slotUserItem = {
            quantity: this.adicionalUsersAmount,
          }
          if (this.userPlanInfo?.addons?.slot_user) {
            let prePlan = this.userPlanInfo.addons.slot_user.find(
              (el) => el.charge === 'pre'
            )
            if (prePlan) {
              slotUserItem.id = prePlan.subscription_item
            } else {
              slotUserItem.price = this.usersAddon.id
            }
          } else {
            slotUserItem.price = this.usersAddon.id
          }
          items.push(slotUserItem)
        } else {
          if (this.initialAddonsAmount.users >= 1) {
            let prePlan = this.userPlanInfo.addons.slot_user.find(
              (el) => el.charge === 'pre'
            )
            items.push({
              id: prePlan.subscription_item,
              deleted: true,
            })
          }
        }
        let ret = await planApi.previewInvoice(
          this.userPlanInfo.subscription_id,
          this.getLocale().toLowerCase(),
          items
        )
        this.prorateResponse = ret.data
        this.prorateLines = ret.data.lines
        this.prorateDiscount = ret.data.discount

        let prorateObjectsArray = []
        let prorateNextMonthLines = []
        for (let i = 0; i < this.prorateLines.length; i++) {
          let line = this.prorateLines[i]
          const conditions = [
            'Remaining',
            'restante',
            'Tempo não utilizado',
            'Não utilizado',
            'Unused time',
          ]
          if (!conditions.some((el) => line.description.includes(el))) {
            prorateNextMonthLines.push(line)
          }
          this.withoutProrateLines = prorateNextMonthLines
          if (!line.quantity) {
            continue
          }
          let findLine = prorateObjectsArray.find(
            (el) =>
              new Date(el.start * 1000).getDate() ===
                new Date(line.period.start * 1000).getDate() &&
              new Date(el.start * 1000).getMonth() ===
                new Date(line.period.start * 1000).getMonth() &&
              el.end === line.period.end
          )
          if (findLine) {
            let foundLineIndex = prorateObjectsArray.indexOf(findLine)
            prorateObjectsArray[foundLineIndex].objects.push(line)
          } else {
            let objects = []
            objects.push(line)
            prorateObjectsArray.push({
              start: line.period.start,
              end: line.period.end,
              objects,
            })
          }
        }
        prorateObjectsArray = prorateObjectsArray.sort((a, b) => {
          return a.end < b.end ? 1 : -1
        })
        this.prohataObjects = prorateObjectsArray.reverse()
      } catch (e) {
        this.errMsg.prorateMsg = e.response?.data?.errMsg
        this.errCode = e.response?.data?.errCode
        this.errors.prorateError = true
      }
      this.prohataLoading = false
    },
    calcBytes(planStorage) {
      let bytes = 0
      planStorage > 1024
        ? (bytes = (planStorage / 1024) * 1e12)
        : (bytes = planStorage * 1e9)
      return `${prettyBytes(bytes, { maximumFractionDigits: 1 })}`
    },
    getTextStorage() {
      let textStorage = this.calcMegabytes(this.userPlanInfo?.limit?.storage)
      if (this.userPlanInfo?.limit?.storage_plan > 999) {
        textStorage = `${(this.userPlanInfo?.limit?.storage / 1024).toFixed(
          1
        )} GB`
      }
      if (this.userPlanInfo?.limit?.storage_plan > 999999) {
        textStorage = `${(
          this.userPlanInfo?.limit?.storage /
          (1024 * 1024)
        ).toFixed(1)} TB`
      }
      let lastTextCaracter = textStorage
        .slice(textStorage.indexOf('.') + 1)
        .substring(0, 1)
      if (lastTextCaracter === '0') {
        textStorage = textStorage.replace('.0', '')
      }
      return textStorage
    },
    formatNumberToBR(toFormatNumber) {
      return Intl.NumberFormat('pt-BR').format(toFormatNumber)
    },
    async handleStripeSettings() {
      try {
        let ret = await planApi.getReturnUrl(
          'https://dashboard.pandavideo.com.br',
          this.currencyLocale
        )
        this.stripeMenuUrl = ret.data.url
      } catch (error) {
        console.error('error', error)
      }
    },
    async handleChangeCard() {
      this.$router.push({ name: 'UserPlan' })
    },
    timeConverter(timestamp) {
      let a = new Date(timestamp * 1000)
      let locale = this.getLocale().toLowerCase()
      let months
      if (locale === 'en-us') {
        months = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ]
      } else {
        months = [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Maio',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ]
      }
      let month = months[a.getMonth()]
      let date = a.getDate()
      let time = month + ' ' + date
      return time.toUpperCase()
    },
    capitalizeFirstLetter(string) {
      if (!string) return
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    handleMoreDetails() {
      this.$root.$emit(
        'openCustomizePlanDetailsFirst',
        this.prohataObjects,
        this.prorateResponse
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.text--current-month {
  text-transform: uppercase;
}

.text--month-listing {
  background: var(--v-progressBar-lighten1);
}

.text--month-listing--dark {
  background: #60606038;
}

.border-bottom--gray {
  border-bottom: 1px solid #cdcdcd;
}

small {
  line-height: 20px;
}
.cardPlanAttributes {
  font-size: 14px;
  line-height: 12px;
  letter-spacing: 0.08em;
  color: #878787;
}
.centered-input >>> input {
  text-align: center;
}
.textButton {
  background: none;
  border: none;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1;
}
.footerText {
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.05em;
}
.blackSubtitle {
  color: rgba(0, 0, 0, 0.87);
}
.gray-text {
  color: #878787;
}
.text-caption-bolder {
  font-weight: bolder;
}
.cartPlanText {
  font-weight: 500;
  font-size: 18px;
  line-height: 120%;
}
.cartBenefitsText {
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
}
.cartSubPricesText {
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
}
.cartPriceText {
  font-weight: 400;
  font-size: 20px;
  line-height: 120%;
}
.customizeChangePlanText {
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
}
.customizeItemsText {
  font-weight: 400;
  font-size: 14px;
}
.customizeWarnText {
  font-weight: 400;
  font-size: 13px;
}
.v-icon--keep-light {
  color: rgba(0, 0, 0, 0.54);
}

.bg-dark {
  .intro {
    &__btn {
      --intro-background-color: rgba(255, 255, 255, 0.54);
      --intro-foreground-color: #000;
    }
  }
}

.intro {
  &__btn {
    --intro-background-color: var(--v-neutral-lighten1);
    --intro-foreground-color: var(--v-neutral-lighten4);

    position: relative;
    top: 0.5px;

    &::v-deep {
      .v-icon {
        background-color: var(--intro-background-color);
        border-radius: 100%;

        &[class*='mdi-'] {
          &::before {
            color: var(--intro-foreground-color);
          }
        }
      }
    }
  }
}
</style>
